import ReactPlayer from 'react-player';
import styles from '../../Style/FeaturesModal.module.scss';

const recordings: { title: string; url: string }[] = [
  { title: 'Recordings', url: 'https://www.youtube.com/watch?v=19Ne0Uq0ze0' },
  { title: 'Validate', url: 'https://www.youtube.com/watch?v=MJj3DcSIaLA' },
  { title: 'MOOD Webinar 2022', url: 'https://www.youtube.com/watch?v=pduwYau5coM' },
];

export function RecordingsSection() {
  return (
    <>
      {recordings.map((recording) => (
        <div className={styles.recordingItems} key={recording.url}>
          <h2>{recording.title}</h2>
          <div className={styles.reactPlayer}>
            <ReactPlayer url={recording.url} controls={true} width="100%" height="100%" />
          </div>
        </div>
      ))}
    </>
  );
}
